import { GET_JOB_PHASES } from '../../store/jobPhases/getters/getterTypes';

export default {
  computed: {
    sitePhases() {
      return this.$store.getters[GET_JOB_PHASES] || [];
    },
    activeReportSections() {
      const phaseId = this.$store.state.ReportsModule.selectedPhaseId;
      if (!phaseId) return null;
      const phase = this.sitePhases.find((p) => p._id === phaseId);
      if (!phase || !phase.reportSections || !phase.reportSections.length)
        return null;
      return phase.reportSections;
    },
  },
  methods: {
    isSectionVisible(key) {
      return (
        !this.activeReportSections || this.activeReportSections.includes(key)
      );
    },

    isTaskVisibleForPhase(task) {
      const phaseId = this.$store.state.ReportsModule.selectedPhaseId;
      if (!phaseId) return true;
      return task.jobPhaseId === phaseId
        ? this.isSectionVisible('inspectionTasks')
        : this.isSectionVisible('additionalTasks');
    },
  },
};
